import http from './http';

/**
 * Envía un ticket de soporte al backend.
 * Ajustar ruta y payload según contrato real de la API.
 */
export const submitSupportTicket = async (payload) => {
  // TODO: Descomentar cuando el endpoint esté disponible en el backend.
  const response = await http.post('/support/tickets', payload);
  return response.data;

  // Respuesta simulada mientras no existe el endpoint.
};

const supportService = {
  submitSupportTicket,
};

export default supportService;
